import { ChevronRight } from "@mui/icons-material";
import { ListItemButton, ListItemText } from "@mui/material";
import { useEffect } from "react";
import {
  selectedGroupId,
  selectedGroupIdx,
} from "../../Actions/loadGroupsTree";
import { debounce } from "lodash";
import { workerActions } from "../../../../store/slices/workers";
import { useLocation } from "react-router-dom";
import { travelerOpenUI } from "../../GroupsTraveler";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../store/slices/UI";
import { devicesLoadedId } from "../../../../store/actions/devices/getRootDevices";
import { recursiveRequestId } from "../../../UI/BasicLayout/Components/FilterPlusActions/Recursive";

const ListItem = (props) => {
  const { id, idx, name, childrenIdx, trail, selected, selectedGroup } = props;
  const { dispatch, navigate } = useUIBp();
  const location = useLocation();

  let bgcolor = undefined;

  if (selected) {
    bgcolor = `rgba(0, 167, 132, 0.2 )`;
  } else if (trail) {
    bgcolor = `rgba(0, 167, 132, 0.1 )`;
  }

  useEffect(() => {
    if (trail || selected) {
      const element = document.getElementById("group-" + id);
      element.scrollIntoView({
        behavior: "instant",
        block: "nearest",
        inline: "start",
      });
    }
  }, [id, trail, selected, selectedGroup]);

  const debouncedClick = debounce((e) => {
    if (e.detail === 1) {
      dispatch(UIactions.setValue({ id: selectedGroupId, value: id }));
      dispatch(UIactions.setValue({ id: selectedGroupIdx, value: idx }));
    } else if (e.detail > 1) {
      const navTo = `${location.pathname}?group=${id}`;
      navigate(navTo);
      dispatch(UIactions.setValue({ id: travelerOpenUI, value: false }));
      dispatch(workerActions.clear(devicesLoadedId));
      dispatch(UIactions.clear(recursiveRequestId));
    }
  }, 200);

  const onClick = (e) => {
    debouncedClick(e);
  };

  return (
    <ListItemButton {...{ id: "group-" + id, onClick, sx: { bgcolor } }}>
      <ListItemText
        primary={name}
        primaryTypographyProps={{ fontSize: 13, noWrap: true }}
      />
      {childrenIdx.length ? (
        selected || trail ? (
          <ChevronRight color="primary" fontSize="10px" />
        ) : (
          <ChevronRight fontSize="10px" />
        )
      ) : null}
    </ListItemButton>
  );
};

export default ListItem;
